import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface WizardHeaderProps {
  steps: string[];
  activeStep: number;
}

const CIRCLE_SIZE = 34;

const WizardHeader: React.FC<WizardHeaderProps> = ({ steps, activeStep }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
      {steps.map((label, index) => {
        const isDone = index < activeStep;
        const isActive = index === activeStep;

        return (
          <React.Fragment key={label}>
            {index > 0 && (
              <Box
                sx={{
                  flex: 1,
                  height: '2px',
                  mt: `${CIRCLE_SIZE / 2}px`,
                  mx: { xs: 0.5, sm: 1.5 },
                  borderRadius: 1,
                  bgcolor: index <= activeStep ? 'primary.main' : 'divider',
                  transition: 'background-color 0.2s ease',
                }}
              />
            )}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: { xs: 56, sm: 80 },
              }}
            >
              <Box
                sx={{
                  width: CIRCLE_SIZE,
                  height: CIRCLE_SIZE,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: '0.9rem',
                  bgcolor: isDone || isActive ? 'primary.main' : 'grey.200',
                  color: isDone || isActive ? '#fff' : 'text.secondary',
                  transition: 'background-color 0.2s ease',
                }}
              >
                {isDone ? <CheckIcon sx={{ fontSize: 18 }} /> : index + 1}
              </Box>
              <Typography
                variant="caption"
                sx={{
                  mt: 1,
                  fontWeight: isActive ? 700 : 500,
                  color: isActive ? 'text.primary' : 'text.secondary',
                  fontSize: { xs: '0.68rem', sm: '0.8rem' },
                  textAlign: 'center',
                  lineHeight: 1.2,
                }}
              >
                {label}
              </Typography>
            </Box>
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default WizardHeader;
